import { BaSeButton, BaSeParagraph, BaSeSmall2 } from '@base/react';
import React from 'react';
import logoEmpretecArena from '../../assets/arena.png';
import empretec1 from '../../assets/empretec-1.jpg';
import empretec2 from '../../assets/empretec-2.jpg';
import empretec3 from '../../assets/empretec-3.jpg';
import empretec4 from '../../assets/empretec-4.jpg';

import homenArena from '../../assets/homen-arena.png';
import homenRural from '../../assets/homen-rural.png';
import mulherEmpretec from '../../assets/mulher-empretec.png';
import mulherEmpretecStartup from '../../assets/mulher-startup.png';

import logoEmpretecRural from '../../assets/rural.png';
import logoEmpretecStartup from '../../assets/startup.png';
import logoEmpretec from '../../assets/tradicional.png';
import { FormContext } from '../../hook/form-context';
import { useDisplay } from '../../hook/useDisplay';
import {
  AlignButton,
  Container,
  ContainerImg,
  ContainerInfos,
  ContainerText,
  ContainetSection,
  Content,
} from './style';

function KnowEmpretec() {
  const { handleMenuClick } = React.useContext(FormContext);
  const { isLargeDisplay } = useDisplay();

  return (
    <Container id="2">
      <ContainerText>
        <BaSeParagraph>
          Conheça as versões do <strong>Empretec</strong> mais adequada para
          você
        </BaSeParagraph>
      </ContainerText>

      <Content>
        <ContainetSection bgColor="#739FF8">
          <ContainerInfos bgColor="#0015C1">
            <img src={logoEmpretec} width="60%" alt="img-empretec" />
            <p>
              O Empretec é destinado aos empreendedores que precisam desenvolver
              habilidades empreendedoras. Este seminário oferece uma metodologia
              robusta que promove a excelência e a confiança no mundo dos
              negócios, ajudando a transformar ideias em empreendimentos de
              sucesso.
            </p>

            <strong>
              6 dias
              <br />
              60 horas
            </strong>
          </ContainerInfos>
          {isLargeDisplay() ? (
            <img src={empretec1} width="60%" alt="img-empre2ec" />
          ) : (
            <ContainerImg>
              <img src={mulherEmpretec} alt="img-empre2ec" />
            </ContainerImg>
          )}
        </ContainetSection>

        <ContainetSection bgColor="#83BE73">
          <ContainerInfos bgColor="#477D44">
            <img src={logoEmpretecRural} width="60%" alt="img-empretec" />
            <p>
              O Empretec Rural é dedicado aos produtores rurais que desejam
              inovar e prosperar no campo. Oferecemos ferramentas e
              conhecimentos essenciais para fortalecer a economia rural,
              promovendo a sustentabilidade e o crescimento.
            </p>

            <strong>
              6 dias
              <br />
              60 horas
            </strong>
          </ContainerInfos>

          {isLargeDisplay() ? (
            <img src={empretec2} width="60%" alt="img-empre2ec" />
          ) : (
            <ContainerImg>
              <img src={homenRural} alt="img-empre2ec" />
            </ContainerImg>
          )}
        </ContainetSection>

        <ContainetSection bgColor="#C380CF">
          <ContainerInfos bgColor="#74307C">
            <img src={logoEmpretecArena} width="60%" alt="img-empretec" />
            <p>
              No Empretec Arena, a competição impulsiona a inovação e o
              crescimento acelerado. Este seminário é intensivo e projetado para
              aqueles que prosperam em ambientes desafiadores e desejam
              conquistar novos mercados. Prepare-se para um ambiente dinâmico
              que estimula a criatividade e a excelência empresarial.
            </p>

            <div>
              <strong>
                1 noite e 4 dias <br />
                44 horas
              </strong>
              <br />
              <BaSeSmall2 isItalic color={'#fff'}>
                Empresários que já fizeram o Empretec podem participar do
                Empretec Arena.
              </BaSeSmall2>
            </div>
          </ContainerInfos>

          {isLargeDisplay() ? (
            <img src={empretec3} width="60%" alt="img-empre2ec" />
          ) : (
            <ContainerImg>
              <img src={homenArena} alt="img-empre2ec" />
            </ContainerImg>
          )}
        </ContainetSection>

        <ContainetSection bgColor="#A1D8F4">
          <ContainerInfos bgColor="#63BAF9">
            <img src={logoEmpretecStartup} width="60%" alt="img-empretec" />
            <p>
              O Empretec Startup é o seminário ideal para transformar suas
              ideias em soluções digitais de sucesso. Focado em empreendedores
              de startups com uma mentalidade ágil e inovadora, este programa
              oferece as ferramentas e o suporte necessários para navegar pelo
              mundo tecnológico e acelerar seu crescimento no mercado digital.
            </p>

            <strong>
              5 dias
              <br />
              50 horas
            </strong>
          </ContainerInfos>

          {isLargeDisplay() ? (
            <img src={empretec4} width="60%" alt="img-empre2ec" />
          ) : (
            <ContainerImg>
              <img src={mulherEmpretecStartup} alt="img-empre2ec" />
            </ContainerImg>
          )}
        </ContainetSection>
      </Content>
      {/* {isLargeDisplay() ? (
        <Content>
          {listVersions.map((item) => (
            <img src={item} alt="imagem do empretec" />
          ))}
        </Content>
      ) : (
        <ImageContainerVersions>
          {listVersionsMobile.map((item) => (
            <img src={item} alt="imagem do empretec" />
          ))}
        </ImageContainerVersions>
      )} */}

      <AlignButton>
        <BaSeButton
          borderRadius="max"
          isBold
          onClick={() => handleMenuClick('7')}
          color="#0000C9"
          size="big"
          value="Tenho interesse em participar"
        />
      </AlignButton>
    </Container>
  );
}

export default KnowEmpretec;
